<template>
  <div>
    <div class="dx-fieldset">
      <dx-data-grid id="dxdatagrid"
                    ref="dxdatagrid"
                    key-expr="Code"
                    :data-source="dashdata.list"
                    :show-borders="true"
                    :word-wrap-enabled="true"
                    :show-column-lines="false"
                    :show-row-lines="true"
                    :focused-row-enabled="false"
                    :onCellPrepared="onCellPrepared"
                    :allow-column-reordering="false"
                    :row-alternation-enabled="false"
                    :column-hiding-enabled="true"
                    :onRowClick="onRowClick"
                    :key="componentKey"
                    :onRowCollapsed="onGridRowCollapsed"
                    :onRowExpanded="onGridRowExpanded"
                    :onAdaptiveDetailRowPreparing="onGridAdaptiveDetailRowPreparing"
                    @toolbar-preparing="onToolbarPreparing($event)">
        <dx-grouping :autoExpandAll="false">
          <dx-texts
            :groupContinuedMessage="$t('WebReport.DataGridContinuedMessage')"
            :groupContinuesMessage="$t('WebReport.DataGridContinuesMessage')" />
        </dx-grouping>

        <dx-paging :enabled="false" />
        <dx-sorting mode="none"/>

        <dx-export
          :enabled="false"
          :file-name="getExcelFilename()"
          :customize-excel-cell="customizeExcelCell"/>

        <dx-column  :data-field="groupColumnName"
                    :customizeText="getGroupName"
                    :group-index="0"
                    :sortingMethod="()=>{return 0;}"
                    group-cell-template="summaryCellTemplate" />

        <dx-column  v-if="compareModeEnabled && groupModeEnabled"
                    data-field="CompareGroup"
                    :group-index="1"
                    :sortingMethod="()=>{return 0;}"
                    group-cell-template="summaryCellTemplate" />

        <dx-column  :caption="clusterCaption">
          <dx-column  data-field="Name"
                      :caption="subClusterCaption"
                      :width="260"/>
        </dx-column>

        <dx-column  v-if="compareModeEnabled && !groupModeEnabled"
                    :caption="$t('Webportal.Dashboard.Grid.CompareCaption')">
          <dx-column  data-field="CompareGroup"
                      :caption="activeCompareLabel"
                      cell-template="summaryCellTemplate"
                      :width="100" />
        </dx-column>

        <!-- Dummy column so that all following columns are shown in group rows -->
        <dx-column name="spacer" :width="0" :allowExporting="false" />

        <template v-for="(wave, index) in this.waves" :key="index">
          <dx-column :caption="wave" :width="150">
            <dx-column  :data-field="getWaveResultField(index+1)"
                        :visible="true"
                        :caption="$t('Webportal.Result')"
                        :key="`${index}_result`"
                        :width="85"
                        :hiding-priority="5000-(index*2)"
                        cell-template="resultTemplate"
                        :name="wave">
            </dx-column>
            <dx-column  :data-field="getWaveNumShopsField(index+1)"
                        alignment="left"
                        :visible="true"
                        caption="n"
                        :key="`${index}_shops`"
                        :width="65"
                        :hiding-priority="4999-(index*2)"
                        cell-template="nTemplate"
                        :name="wave + '-n'">
            </dx-column>
          </dx-column>
        </template>

        <dx-column name="WaveCompare" :caption="$t('DealerReport.WaveCompare')" :allowExporting="false">
          <dx-column  id="dxdatagridtotalcol"
                      ref="dxdatagridtotalcol"
                      :allow-sorting="false"
                      data-field="SurveyWave"
                      :caption="$t('Webportal.Dashboard.OverallByQuestion')"
                      cell-template="chartTemplate"
                      :hiding-priority="0"
                      name="##IGNORE##"
                      :allowExporting="false">
          </dx-column>
        </dx-column>

        <dx-column :caption="$t('Webportal.Dashboard.Total')">
          <dx-column  :data-field="getWaveResultField(0)"
                      :visible="true"
                      :caption="$t('Webportal.Result')"
                      cell-template="resultTemplate"
                      :width="85"
                      :hiding-priority="9999"
                      :name="$t('Webportal.Dashboard.Total')">
          </dx-column>
          <dx-column  :data-field="getWaveNumShopsField(0)"
                      alignment="left"
                      :visible="true"
                      caption="N"
                      cell-template="nTemplate"
                      :width="65"
                      :hiding-priority="1"
                      name="N">
          </dx-column>
        </dx-column>

        <dx-summary>
          <!-- Dummy column so that all following columns are shown in group rows -->
          <dx-group-item
            :show-in-group-footer="false"
            :align-by-column="true"
            column="spacer" />
        </dx-summary>

        <dx-group-panel :visible="false"/>

        <dx-search-panel  :visible="true"
                          :width="240"
                          :highlight-case-sensitive="true"
                          />
                          <!-- placeholder="Suchen..."
                          v-if="dashdata && dashdata.list"
                          v-model="searchText"
                          @value-changed="onSearchTextChanged" -->

        <template #collapseall>
          <b-form-checkbox v-model="expandCollapseValue" size="sm"
                           :indeterminate="expandCollapseIndeterminate"
                           @change="onExpandCollapseAllChanged">
            {{ $t('Webportal.Dashboard.ExpandCollapse') }}
          </b-form-checkbox>
        </template>

        <template #groupmode>
          <div class="flex-container group-switch space-left">
            <div for="GroupSwitch">
              {{ $t('Webportal.Dashboard.GroupMode') }}
              <span :id="`groupmode-info-${componentKey}`">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
              </span>
              <BTooltip :target="`groupmode-info-${componentKey}`" triggers="hover">
                {{ $t('Webportal.Dashboard.GroupMode.Description') }}
              </BTooltip>
            </div>
            <label class="switch switch-label switch-secondary space-left">
              <input class="switch-input" type="checkbox"
                    v-model="groupModeEnabled"
                    :disabled="!compareModeEnabled">
              <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
            </label>
          </div>
        </template>

        <template #download>
          <b-row>
            <div class="col-md-auto">
              <b-alert :show="noDataAlert"
                      dismissible
                      @dismissed="noDataAlert=false"
                      variant="warning">
                {{ $t('Webportal.NoDataFound') }}
              </b-alert>
              <b-button class="excelButton"
                        variant="primary"
                        :disabled="isExporting || !dashdata"
                        @click="downloadExcel()"
                        size="sm"
                        :title="$t('Webportal.Download')">
                <font-awesome-icon icon="file-excel" />
              </b-button>
            </div>
            <div class="col-md-1" v-bind:class="{ inlineSpinner: isExporting }"></div>
          </b-row>
        </template>

        <template #resultTemplate="cellData">
          <result-cell :cell-data="cellData"
                       :thresholds="thresholds"
                       :percentageNumberOfDecimalPoints="percentageNumberOfDecimalPoints" />
        </template>

        <template #nTemplate="cellData">
          <result-cell :cell-data="cellData" />
        </template>

        <template #chartTemplate="cellData">
          <chart-cell :cell-data="cellData"
                      :thresholds="thresholds"
                      :percentageNumberOfDecimalPoints="percentageNumberOfDecimalPoints" />
        </template>

        <template #summaryCellTemplate="cellData">
          <summary-cell :cell-data="cellData" />
        </template>
      </dx-data-grid>
    </div>
  </div>
</template>

<script>

import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxPager,
  DxPaging,
  DxSearchPanel,
  DxTexts,
  DxSummary,
  DxSorting,
  DxGroupItem,
  DxValueFormat
} from 'devextreme-vue/data-grid';

import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import ChartCell from './ChartCell.vue';
import ResultCell from './ResultCell.vue';
import SummaryCell from './SummaryCell.vue';
import scale from './Scale';
import ThresholdColor from '@/mixins/ThresholdColor-APP_TARGET';

export default {
  name: 'ResultTable',

  components: {
    DxDataGrid,
    DxExport,
    DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxTexts,
    DxSummary,
    DxSorting,
    DxGroupItem,
    DxValueFormat,
    ChartCell,
    ResultCell,
    SummaryCell,
    scale
  },

  mixins: [ AppConfig, ThresholdColor ],

  props: {
    dashdata: { type: Object, default: null },
    isCluster: {default: true},
    thresholds: null,
    percentageNumberOfDecimalPoints: {type: Number, default: 2},
    activeCompareLabel: {type: String, default: 'N/A'},
    componentId: {type: Number, default: 0}
  },

  watch: {
    dashdata: {
      immediate: true,
      handler(newVal, oldVal) {
        this.handleDataChanged();
        // Nur bei wirklich signifikanten Änderungen neu rendern
        if (newVal?.list?.length !== oldVal?.list?.length) {
          this.$nextTick(() => {
            this.componentKey += 1;
          });
        }
      },
    },

    thresholds(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        this.$nextTick(() => {
          this.componentKey += 1;
        });
      }
    },

    groupModeEnabled(newVal, oldVal) {
      this.handleDataChanged();
    },

    activeCompareLabel(newVal, oldVal) {
      this.handleDataChanged();
    },

    componentId(newVal, oldVal) {
      this.handleDataChanged();
    },
  },

  created() {
    // console.log('ResultTable - created - data: ' + JSON.stringify(this.dashdata));
    this.handleDataChanged();
  },

  data() {
    return {
      waves: [],
      smallscreenactive: false,
      groups: [],
      componentKey: 0,
      groupList: [],
      groupList2: [],
      intervalReference: undefined,
      domManipulationRetryCounter: 0,
      smallScreenSwitchWidth: 120,
      expandCollapseValue: false,
      expandCollapseIndeterminate: false,
      compareModeEnabled: false,
      groupModeEnabled: true,
      chartCellWidth: 250,
      isExporting: false,
      noDataAlert: false,  // Änderung: 0 → false
      // searchText: '',
      // searchDebounceTimer: null,
      exportGroupData: null,
      exportGroupDataScope: null
    };
  },

  computed: {
    groupColumnName: function() {
      return this.isCluster ? 'Code' : 'GroupCode';
    },

    clusterCaption: function() {
      return this.isCluster ? this.$t('Webportal.Cluster') : this.$t('Webportal.Kpi');
    },

    subClusterCaption: function() {
      return this.isCluster ? this.$t('Webportal.ClusterQuestion') : this.$t('Webportal.Kpi');
    }
  },

  methods: {

    onExpandCollapseAllChanged(checked) {
      const grid = this.$refs.dxdatagrid;
      if (grid) {
        if (this.expandCollapseIndeterminate || !this.expandCollapseValue) {
          grid.$_instance.expandAll();
          this.expandCollapseValue = true;
          this.expandCollapseIndeterminate = false;
        } else {
          grid.$_instance.collapseAll();
          this.expandCollapseValue = false;
          this.expandCollapseIndeterminate = false;
        }
      }
    },

    onGridRowCollapsed(event) {
      this.checkRowCollapsedValue();
    },

    onGridRowExpanded(event) {
      this.checkRowCollapsedValue();
    },

    onGridAdaptiveDetailRowPreparing(event) {
      if (event.formOptions && event.formOptions.items) {

        let indexesToRemove = [];

        for (let i=0; i<event.formOptions.items.length; i++) {
          const item = event.formOptions.items[i];
          if (item.column && item.name) {
            if (item.name === '##IGNORE##')
            {
              indexesToRemove.push(i);
            } else {
              item.column.caption = item.name;
            }
          }
        }

        if (indexesToRemove.length > 0) {
          for (let i=indexesToRemove.length-1; i>=0; i--) {
            event.formOptions.items.splice(indexesToRemove[i], 1);
          }
        }
      }
    },

    checkRowCollapsedValue() {
      const grid = this.$refs.dxdatagrid;
      let visibleGroupRows = grid?.$_instance.getVisibleRows()?.filter(row => row.rowType === 'group' && row.groupIndex == 0);

      if (visibleGroupRows && visibleGroupRows.length > 0) {
        let expandedStates = visibleGroupRows.map(row => grid.$_instance.isRowExpanded(row.key));

        this.expandCollapseValue = expandedStates.every(isExpanded => isExpanded);
        this.expandCollapseIndeterminate = !this.expandCollapseValue && expandedStates.some(isExpanded => isExpanded);
      }
      else {
        this.expandCollapseValue = false;
        this.expandCollapseIndeterminate = false;
      }
    },

    onToolbarPreparing(tool) {
      if (!tool || !tool.toolbarOptions) return;

      // // Search Box als erstes hinzufügen
      // tool.toolbarOptions.items.unshift({
      //   location: 'after',
      //   widget: 'dxTextBox',
      //   options: {
      //     width: 240,
      //     placeholder: 'Suchen...', // this.$t('Webportal.Dashboard.Search') ||
      //     mode: 'search',
      //     valueChangeEvent: 'keyup',
      //     onValueChanged: (e) => {
      //       this.searchText = e.value;
      //       const grid = this.$refs.dxdatagrid;
      //       if (grid && grid.$_instance) {
      //         try {
      //           grid.$_instance.searchByText(e.value);
      //         } catch (err) {
      //           console.warn('Search failed:', err);
      //         }
      //       }
      //     }
      //   }
      // });

      tool.toolbarOptions.items.unshift({
        location: 'before',
        template: 'groupmode'
      });

      tool.toolbarOptions.items.unshift({
        location: "after",
        template: "download"
      });

      tool.toolbarOptions.items.unshift({
        location: 'before',
        template: 'collapseall'
      });
    },

    ensureSurveyWaveOrder(dataItem) {
      // if length of contained waves are different of expected, fill it with dummies
      // the data will always contains the 'total' wave, which we have to ignore here
      if (dataItem?.SurveyWave?.length > 0 && dataItem.SurveyWave.length != (this.waves.length + 1)) {
        let newWaveArray = [];
        let oldWaveArray = [...dataItem.SurveyWave];

        // add total wave
        newWaveArray.push(oldWaveArray[0]);

        // add each wave
        for (let index=0; index < this.waves.length; index++) {

          const currWaveName = this.waves[index];
          let waveData = oldWaveArray.find(w => w.Name === currWaveName);

          // if the wave data is found we add it otherwise wwe have to add a dummy
          if (waveData != null || waveData != undefined) {
            newWaveArray.push(waveData);
          } else {
            newWaveArray.push({
              Id: undefined,
              Name: currWaveName,
              Result: undefined,
              PointsReached: undefined,
              PointsMax: undefined,
              CheckCountTotal: undefined,
              AnsweredQuestionCount: undefined
            });
          }
        }

        // replace the wave data
        dataItem.SurveyWave = newWaveArray;
      }
    },

    handleDataChanged() {

      this.groupList = [];
      this.groupList2 = [];

      // get wave count
      if (this.dashdata?.data?.[0]?.OverallByWave?.[0]?.SurveyWave?.length > 0) {

        let newWaves = [];
        for (let wave of this.dashdata.data[0].OverallByWave[0].SurveyWave) {
          newWaves.push(wave.Name);
        }
        this.waves = newWaves;
        //console.log("handleDataChanged - waves: " + JSON.stringify(this.waves));

        // get all KPI Cluster
        for (let item of this.dashdata.list) {

          // groupList
          if (this.isCluster) {
            if (!this.groupList.includes(item.Code)) {
              this.groupList.push(item.Code);
            }
          } else {
            if (!this.groupList.includes(item.GroupCode)) {
              this.groupList.push(item.GroupCode);
            }
          }

          // groupList2
          if (!this.groupList2.includes(item.CompareGroup)) {
            this.groupList2.push(item.CompareGroup);
          }
        }
        //console.log("handleDataChanged - groupList: " + JSON.stringify(this.groupList));

        // we have to add additional waves for all cluster and kpi values,
        // because datagrid binding need exactly all waves in all data items
        // if you have two different surveys selected it's possible that
        // clusters or kpis does'nt have all waves included
        for (let dataItem of this.dashdata.list) {
          this.ensureSurveyWaveOrder(dataItem);
          this.ensureSurveyWaveOrder(dataItem?.Parent);
          this.ensureSurveyWaveOrder(dataItem?.RootParent);
        }
      }

      // determine group mode
      this.compareModeEnabled = this.dashdata ? this.dashdata.isGroupMode : false;
      this.checkRowCollapsedValue();

      // // Am Ende: Grid State neu setzen - MIT TRY-CATCH
      // this.$nextTick(() => {
      //   const grid = this.$refs.dxdatagrid;
      //   if (grid?.$_instance) {
      //     try {
      //       grid.$_instance.clearSelection();
      //       grid.$_instance.clearFilter();
      //     } catch (err) {
      //       console.warn('Grid state reset failed:', err);
      //     }
      //   }
      // });
    },

    getWaveName(index) {

      // console.log('getWaveName with requested index: ' + index);
      // console.log(this.dashdata.list[0]);

      // usually we have to reduce the index, because
      // the v-for loop will return index based on 1
      // but we also have to ignore the total wave
      if (this.dashdata && this.dashdata.list && this.dashdata.list.length > 0 && this.dashdata.list[0].SurveyWave && this.dashdata.list[0].SurveyWave.length > index) {
        return this.dashdata.list[0].SurveyWave[index].Name;
      } else {
        return "Wave";
      }
    },

    onRowClick: function(e) {
      // console.log('ResultTable - onRowClick', e);
      if (e.groupIndex !== undefined && e.isExpanded !== undefined) {
        if (e.isExpanded) {
          e.component.collapseRow(e.key);
        } else {
          e.component.expandRow(e.key);
        }
      }
    },

    onCellPrepared: function(e){
      if(e.rowType == 'header') {
        e.cellElement.classList.add('header-cell-custom');
      } else {
        e.cellElement.classList.add('data-cell-custom');
      }
    },

    getWaveResultField: function(index) {
      // console.log('getWaveResultField: ' + index);
      return 'SurveyWave[' + index + ']';
    },

    getWaveNumShopsField: function(index) {
      return 'SurveyWave[' + index + '].CheckCountTotal';
    },

    downloadExcel() {
      const grid = this.$refs.dxdatagrid;

      if (grid) {
        this.exportGroupData = null;
        this.exportGroupDataScope = null;
        grid.$_instance.exportToExcel(false);
      }
    },

    customizeExcelCell(options) {
      //console.log(options, options.gridCell?.rowType, options.gridCell?.column.dataField, this.exportGroupDataScope, this.exportGroupData)
      var gridCell = options.gridCell;
      if (!gridCell)
        return;

      if (gridCell.rowType === 'group') {
        if (gridCell.column.dataField === this.groupColumnName &&
            options.value && options.value.indexOf(':') >= 0) {
          // Process group column
          let groupCode = options.value.substring(options.value.indexOf(':') + 1).trimStart();
          this.exportGroupDataScope = this.dashdata.list.find(item => item[this.groupColumnName] === groupCode);
          this.exportGroupData = this.exportGroupDataScope?.RootParent;
          options.value = groupCode;
        } else
        if (gridCell.column.dataField === 'CompareGroup' &&
            options.value && options.value.indexOf(':') >= 0 && options.value.indexOf('^') >= 0) {
          // Process compare group column
          if (this.exportGroupDataScope)
          {
            let compareGroup = options.value.substring(options.value.indexOf(':') + 1).trimStart();
            this.exportGroupDataScope = this.dashdata.list.find(item =>
              item[this.groupColumnName] === this.exportGroupDataScope[this.groupColumnName] && item.CompareGroup === compareGroup);
            this.exportGroupData = this.exportGroupDataScope?.Parent;
          }
          options.value = options.value.substring(options.value.indexOf('^') + 1);
        } else if (this.exportGroupData) {
          // Apply group row values
          let cellData = _.get(this.exportGroupData, gridCell.column.dataField);
          options.value = gridCell.column.cellTemplate === 'resultTemplate' ? cellData.Result : cellData;

          if (APP_TARGET === "cupra" && gridCell.column.cellTemplate === 'resultTemplate' && options.value != null)
            options.value += ` (#Q: ${cellData.AnsweredQuestionCount})`
        }
      } else
      if (gridCell.rowType === 'data' && options.gridCell.column.dataField === 'CompareGroup' &&
          options.value && options.value.indexOf('^') >= 0) {
        // Remove compare group index
        options.value = options.value.substring(options.value.indexOf('^') + 1);
      }
      else if (gridCell.rowType === 'data' && gridCell.column.cellTemplate === 'resultTemplate')
        options.value = gridCell.value?.Result;
    },

    getSummaryWaveName(name) {
      const indexOfLast = name.lastIndexOf('_');
      const indexOfFirst = name.indexOf('_');
      const retVal = name.substring(indexOfFirst+1,indexOfLast);
      return retVal;
    },

    getSummaryIndexOutOfName(name) {
      const indexStr = name.substring(name.lastIndexOf('_') + 1);
      return Number(indexStr);
    },

    getExcelFilename() {
      const now = new Date();
      return 'AnalysisGridData_' + now.getFullYear() + '_' + (now.getMonth()+1) + '_' + now.getDate() + '_' + now.getHours() + '_' + now.getMinutes() + '_' + now.getSeconds();
    },

    getWidthToBar() {
      // 7 -> column padding
      // 1 -> border
      // 30 -> Group arrow (for each level)
      // 100 -> Compare column
      // 260 -> Cluster/KPI column
      // Each wave will take 150px width (Total 'Wave' is at the end)
      let retVal = '0px';

      if (this.dashdata && this.dashdata.list && this.dashdata.list.length > 0) {

        let width = (7 + 1 + 30 + 260 + Math.max(this.dashdata.list[0].SurveyWave.length - 1, 0) * 150);
        // add additional 30px, if group mode is enabled
        if (this.compareModeEnabled) {
          if (this.groupModeEnabled) {
            width += 30; // Group arrow
          } else {
            width += 100; // Compare column
          }
        }

        retVal = width + 'px';
      }
      return retVal;
    },

    getGroupName(cellInfo) {
      if (this.isCluster) {
        let clusterItem = this.dashdata.data[0].Cluster.find(obj => obj.Code === cellInfo.value);
        return clusterItem != null ? clusterItem.Name : cellInfo.value;
      } else {
        let kpiGroupItem = this.dashdata.data[0].KPIGroup.find(obj => obj.Code === cellInfo.value);
        return kpiGroupItem != null ? kpiGroupItem.Name : cellInfo.value;
      }
    },
  },
};

</script>

<style lang="scss" scoped>
:deep(.dx-datagrid-rowsview .dx-row.dx-group-row:not(.dx-row-focused)) {
  background-color: transparent;
}
:deep(.dx-datagrid), :deep(.dx-toolbar) {
  background-color: transparent !important;
}
:deep(.dx-datagrid-headers) {
  background-color: transparent !important;
  border-bottom: none;
}
:deep(.header-cell-custom) {
  font-weight: bold;
  color: var(--dx-datagrid-header-color);
  background-color: var(--bs-primary);
}
:deep(.data-cell-custom) {
  background-color: var(--dx-datagrid-cell-bg);
}

.excelButton {
  background-color: #107c41;
  border-color: #107c41;
  &:hover {
    color: #0e6c36;
    background-color: #fff;
    border-color: #0e6c36;
  }
}

.flex-container {
  display: flex;
  align-items: center;
}

.space-left {
  margin-left: 5px;
}

.card-body {
  padding: 0px;  margin-bottom: 0.5rem;
}

.dx-fieldset {
  margin: 1rem;
}

#tasks {
    min-height: 150px;
}

#tasks .dx-treelist-rowsview td {
    vertical-align: middle;
}

.pitem {
  text-align: center;
  height: 40px;
  /* width: 300px; */
  margin-left: 347px;
  margin-right: 228px;
}
</style>
